import { fa0, fa1, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export default function Card({ icon, title, numberIcons, onClick, className, iconSize, nodate, onDelete }) {
  return (
    <div className={`${className} p-5 w-full grid grid-cols-3 rounded cursor-pointer shadow-lg`}>
      <div onClick={onClick} className='text-lg col-span-2 text-white'>
        {title}
        <div>
          <span>
            {numberIcons?.map((icon) => (
              <FontAwesomeIcon icon={icon} size={'2x'} color='white' />

            ))}
          </span>
        </div>
        {!nodate && <div className='text-white text-sm mt-10'>July 17 2023</div>}
      </div>
      {
        onDelete ?
          <div className='text-lg col-span-1 flex justify-end items-center text-white uppercase'>
            <div onClick={onDelete} className='w-8 h-8 rounded-lg flex justify-center items-center bg-red-500'>
              <FontAwesomeIcon icon={faTrashAlt} size={iconSize || '1x'} />
            </div>
          </div>
          :
          <div className='text-lg col-span-1 flex justify-end items-center text-white uppercase'>
            <FontAwesomeIcon icon={icon} size={iconSize || '2x'} />
          </div>
      }
    </div>
  )
}
